import React, { useState } from 'react'
import PropTypes from 'prop-types'
import {
  Button,
  Modal as BsModal,
  ModalBody,
  ModalHeader,
  Badge,
  ModalTitle,
} from 'react-bootstrap'

export function Modal({ data, show, toggleModal }) {
  if (data === undefined) return null
  const [JSONdata, setJSONdata] = useState()
  return (
    <BsModal show={show} bsSize="large">
      <ModalHeader className="d-flex">
        <ModalTitle>
          {data.user_info.first_name} {data.user_info.last_name}
        </ModalTitle>
        <Button
          className="ml-auto"
          onClick={() => {
            toggleModal()
            setJSONdata()
          }}
        >
          <i className="fas fa-times"></i>
        </Button>
      </ModalHeader>
      <ModalBody>
        <div className="d-flex">
          <div className="d-flex flex-column">
            {data &&
              data.rules_violated.map(item => (
                <Button
                  key={item.name}
                  className="m-3 p-3"
                  onClick={() => setJSONdata(JSON.stringify(item, null, 4))}
                >
                  <h5>{item.name}</h5>
                  <Badge
                    className={` ${
                      item.severity === 'warning'
                        ? 'bg-warning'
                        : item.severity === 'critical'
                        ? 'bg-danger'
                        : ''
                    }`}
                  >
                    {item.severity}
                  </Badge>
                </Button>
              ))}
          </div>
          <div className="m-3">
            {JSONdata && (
              <pre className="maxw-675px" style={{ width: '675px' }}>
                {JSONdata}
              </pre>
            )}
          </div>
        </div>
      </ModalBody>
    </BsModal>
  )
}

Modal.propTypes = {
  data: PropTypes.array,
  show: PropTypes.bool.isRequired,
  toggleModal: PropTypes.func.isRequired,
}
